// extracted by mini-css-extract-plugin
export default {"pageWrap":"Fc-z","fullWidth":"Gc-z","heading":"Hc-z","fullBleed":"Ic-z","hidden":"Jc-z"};